
























































import {
    Component, Inject, Model, Vue,
} from 'vue-property-decorator';
import ODynamictextfield from '@/components/dashboard/addProduct/productDetailsForm/ODynamictextfield.vue';
import OTextfield from '@/components/dashboard/addProduct/productDetailsForm/OTextfield.vue';
import { ProductTemplate } from '@/assets/interface/Product';
import Sortable from 'sortablejs';
import { Validator } from 'vee-validate';

@Component({
    components: {
        OTextfield,
        ODynamictextfield,
    },
})
export default class ProductDetailsForm extends Vue {
    @Model('change', { type: Object }) public product!: ProductTemplate;

    // this is for veevalidate
    @Inject('$validator') public $validator!: Validator;

    public dictionary = {
        en: {
            messages: {
                required: () => 'the field is required',
            },
        },
    };

    public productDetailsFormsignInEvent(action: string, label: any) {
        this.$ga.event('ProductDetailsForm', 'click', action, label);
    }

    public removeField(index: number) {
        this.productDetailsFormsignInEvent('Click remove field', 'X icon');
        this.product.fields.splice(index, 1);
    }

    public addField() {
        this.productDetailsFormsignInEvent('Click add field', '+ icon');
        this.product.fields.push({
            id: this.newId,
            title: '',
            content: '',
        });
        this.newId = this.newId + 1;
    }

    public mounted() {
        this.initSortable();
        this.$validator.localize(this.dictionary);
    }

    public updatePosition(oldIndex: any, newIndex: any) {
        const updatePosition = (list: any[]) => list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
        this.alterList(updatePosition);
    }

    public alterList(onList:any) {
        onList(this.product.fields);
    }

    private initSortable() {
        const el = document.getElementById('add-product__dynamic--fields');
        const sortable = Sortable.create(el!, {
            animation: 150,
            ghostClass: 'blue-background-class',
            handle: '.handle',
            onUpdate: ((res) => {
                this.updatePosition(res.oldIndex, res.newIndex);
            }),
        });
    }

    private newId = 4;
}
